import styled from "styled-components";

import { ILineBreakStyleProps, IRhytStyleProps } from "./interfaces";

export const $paddingTop = 8;
export const $paddingRight = 8;
export const $paddingBottom = 2;
export const $paddingLeft = 12;

export const Rhyt = styled.div<IRhytStyleProps>`
    overflow: hidden;
    svg {
        width: ${p => p.svgWidth}px;
        height: 100px;
        display: flex;
    }
    &.Selectable {
        &:hover {
            cursor: pointer;
            svg {
                fill: ${p => p.theme.c.greyE};
            }
        }
    }
`;

export const Bar = styled.div`
    display: flex;
    transition: background-color 0.3s;
    background-color: ${p => p.theme.c.info};
    height: 70px;
    position: relative;
    justify-content: space-evenly;

    &.Christmas {
        background-color: ${p => p.theme.c.christmasBlue};
    }

    &.Edit {
        margin: 10px;
        border-radius: 7px;
        overflow: hidden;
        box-shadow: 0 0 4.3px 0 ${p => p.theme.c.blackShadow3};
    }

    &:first-child {
        padding-left: 17px;
    }

    &.Passive {
        .Rhyt {
            svg {
                fill: inherit;
            }
        }
    }

    &.Correct {
        background-color: ${p => p.theme.c.correct} !important;
    }

    &.Incorrect {
        background-color: ${p => p.theme.c.incorrect} !important;
    }

    &.Active {
        background-color: ${p => p.theme.c.check} !important;
    }

    &.DragBox {
        &:first-child {
            padding: ${$paddingTop}px ${$paddingRight}px ${$paddingBottom}px ${$paddingLeft}px;
            cursor: pointer;
            box-shadow: 0 0 0 2px black inset;
            border-radius: 20px;
        }
    }

    &.Christmas.DragBox {
        &:first-child {
            box-shadow: 0 0 0 5px ${p => p.theme.c.christmasLightBlue} inset;
            border-radius: 0;
        }
    }
`;

export const RemoveBox = styled.div`
    padding: 0 8px;
    line-height: 70px;
    text-align: center;
    cursor: pointer;

    &:hover {
        background-color: rgba(255, 255, 255, 0.2);
    }
`;

export const OrderBtn = styled.div`
    background-color: ${p => p.theme.c.greyA};
    padding: 0 4px;
    line-height: 70px;

    cursor: pointer;

    &:hover {
        background-color: lightgrey;
    }
`;

export const Selector = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;

    &:hover {
        background-color: rgba(250, 250, 250, 0.2);
    }
`;

export const LineBreak = styled.div<ILineBreakStyleProps>`
    position: absolute;
    top: 0;
    right: 6px;
    padding: 4px;
    cursor: pointer;

    .i-system-break {
        font-size: 32px;
        color: ${p => (p.isActive ? p.theme.c.white : p.theme.c.grey3)};
        transform: ${p => (p.isActive ? "scale(1.2)" : "none")};
        transition: 300ms;
        display: inline-block;
    }

    &:hover {
        .i-system-break {
            color: ${p => (p.isActive ? p.theme.c.white : p.theme.c.disabled)};
        }
    }
`;

export const PlayBarButton = styled.button`
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 4px 6px;
    opacity: 0.6;
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;

    .i-play {
        color: rgba(0, 0, 0, 0.4);
        font-size: 28px;
    }
`;
